import {
  alpha,
  Autocomplete,
  Box,
  Grid,
  Skeleton,
  styled,
  Switch,
  TextField,
  Typography,
  Breadcrumbs,
  Tooltip,
} from "@mui/material";
import InfoPopover from "../../Components/Common/poper/InfoPopover";
import { useEffect, useRef, useState } from "react";
import DataTable from "../../Components/Common/datatable/DataTable";
import { ArrowDropDownIcon } from "@mui/x-date-pickers";
import ButtonComponent from "../../Components/Common/button/Button";
import { setBottlerData } from "../../redux/entitySlice";
import ApiService from "../../utils/fetch";
import { MessagePopup } from "../../Components/Common/messagePopup/MessagePopup";
import EditIcon from "@mui/icons-material/Edit";
import { Link, useLocation, useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useSelector } from "react-redux";
import { useSupport } from "../../context/SupportContext";
//check

function ForecastPartnerConfiguration() {
  const location = useLocation();
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [changedRows, setChangedRows] = useState(new Set());
  let { combinationDetails, setCombinationDetails } = useSupport();

  const gridRef = useRef(null);
  const navigate = useNavigate();

  const [isSwitchOn, setIsSwitchOn] = useState(false);

  const handleSwitchChange = () => {
    setIsSwitchOn(!isSwitchOn);
  };

  const BottlerData = useSelector((state) => state.user.selectedBottler?.id);
  const BottlerName = useSelector(
    (state) => state.user.selectedBottler?.bottler
  );

  const pagination = true;
  const paginationPageSize = 10;
  const paginationPageSizeSelector = [5, 10, 20, 50, 100];

  useEffect(() => {
    if (BottlerData) {
      fetchUserDetails();
    }
  }, [BottlerData]);

  const fetchUserDetails = async () => {
    if (!BottlerData) return;
    try {
      setLoading(true);
      const response = await ApiService.get(
        `/v1/Onboard/getCustomerCofig?bottlerId=${BottlerData}`
      );
      setFilteredData(response.data.data);
    } catch (error) {
      console.error("Error fetching user details:", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const resizeGrid = () => {
      if (gridRef.current && gridRef.current.api && filteredData.length > 0) {
        gridRef.current.api.sizeColumnsToFit();
      }
    };

    resizeGrid();

    window.addEventListener("resize", resizeGrid);
    return () => window.removeEventListener("resize", resizeGrid);
  }, [filteredData]);

  const PartnerColumnDefinition = [
    {
      headerCheckboxSelection: true,
      checkboxSelection: true,
      field: "supportCheckbox",
      headerName: "",
      sortable: false,
      width: 50,
      suppressSizeToFit: true,
    },
    {
      field: "customerName",
      headerName: "Forecast Partner",
      sortable: true,
      unSortIcon: true,
      width: 250,
      minWidth: 250,
      valueGetter: (params) => {
        const { customerId, customerName } = params.data;
        return `${customerId || ""} - ${customerName || ""}`;
      },
      cellRenderer: (params) => {
        const display = params.value;
        return (
          <Tooltip title={<span>{display}</span>} arrow>
            <div>{display}</div>
          </Tooltip>
        );
      },
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
    },
    {
      field: "shortTermDuration",
      headerName: "Short Term Duration(Months)",
      cellClass: "red-border",
      width: 300,
      minWidth: 300,
      cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
      sortable: true,
      unSortIcon: true,
      editable: true,
      cellEditorParams: {
        useFormatter: false,
        inputType: "number",
      },
      valueSetter: (params) => {
        let newValue = params.newValue;
        const numericValue = parseFloat(newValue);
        if (isNaN(numericValue)) {
          MessagePopup({
            icon: "error",
            title: "Invalid Input",
            message: "Please enter a valid numeric value.",
          });
          return false;
        }
        if (numericValue < 3 || numericValue > 5) {
          MessagePopup({
            icon: "error",
            title: "Invalid Range",
            message: "Please enter a value between 3 and 5.",
          });
          return false;
        }

        params.data.shortTermDuration = numericValue;
        return true;
      },
      cellRenderer: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              //color: params.value ? "black" : "red",
            }}
          >
            <span>{params.value || "Enter a duration (3-5months)"}</span>
          </div>
        );
      },
    },
    {
      field: "shortTermGranularity",
      headerName: "Short Term Granularity",
      sortable: true,
      unSortIcon: true,
      editable: false, // Disable editing since it's fixed to "WEEK"
      width: 230,
      minWidth: 230,
      valueGetter: () => "WEEK", // Always return "WEEK"
    },
    {
      field: "longTermDuration",
      headerName: "Long Term Duration(Months)",
      width: 290,
      minWidth: 290,
      cellStyle: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      filter: "agMultiColumnFilter",
      filterParams: {
        filters: [
          {
            filter: "agTextColumnFilter",
          },
          {
            filter: "agSetColumnFilter",
          },
        ],
      },
      sortable: true,
      unSortIcon: true,
      editable: false,
      cellRenderer: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              //color: params.value ? "black" : "red",
            }}
          >
            <span>{params.value || "0"}</span>
          </div>
        );
      },
    },
    {
      field: "longTermGranularity",
      headerName: "Long Term Granularity",
      sortable: true,
      unSortIcon: true,
      editable: true,
      width: 230,
      minWidth: 230,
      cellClass: "red-border",
      cellEditor: "agSelectCellEditor", // Dropdown for editable cells
      cellEditorParams: {
        values: ["MONTH", "WEEK"], // Options for selection
      },
      cellRenderer: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            //color: params.value ? "black" : "red",
          }}
        >
          <span>{params.value || "Select Granularity"}</span>
          <ArrowDropDownIcon
            style={{
              fontSize: 25,
              //color: params.value ? "black" : "red"
            }}
          />
        </div>
      ),
    },
    {
      field: "actions",
      headerName: "Plant Configuration",
      width: 200,
      minWidth: 200,
      cellRenderer: (params) => {
        return (
          <div>
            <EditIcon
              style={{
                marginRight: "10px",
              }}
              onClick={() => update(params)}
            />
          </div>
        );
      },
    },
  ];

  const onCellValueChanged = (params) => {
    if (params.colDef.field === "shortTermDuration") {
      const inputValue = params.newValue;

      // Safely parse the value as an integer
      const shortTermDuration = parseInt(inputValue || 0, 10);
      const maxDuration = 18; // Maximum duration limit for this example

      // Validate the range: shortTermDuration must be between 1 and 17
      if (shortTermDuration < 1 || shortTermDuration >= maxDuration) {
        MessagePopup({
          icon: "error",
          title: "Invalid Input",
          message: "Please enter a value between 1 and 17.",
        });

        // Reset to the old value if invalid
        params.node.setDataValue("shortTermDuration", params.oldValue);
        return;
      }

      // Calculate longTermDuration dynamically
      const longTermDuration = maxDuration - shortTermDuration;

      // Update the longTermDuration cell value
      params.node.setDataValue("longTermDuration", longTermDuration);
    }

    const rowId = params.node.id;
    setChangedRows((prev) => new Set(prev).add(rowId));
    // Ensure the node is selected if it's not already selected
    // if (!params.node.isSelected()) {
    //   params.node.setSelected(true);
    // }
    params.data.isDataChanged = true;
    // Set the flag to indicate unsaved changes have been made
    setHasUnsavedChanges(true);
  };

  const update = async (params) => {
    if (hasUnsavedChanges) {
      await MessagePopup({
        icon: "warning",
        title: "Unsaved Changes",
        message: "Save your changes before going to Plant Configuration",
      });
      return;
    }
    navigate("/plant-config", { state: { data: params.data } });
  };

  const custom = async (params) => {
    if (hasUnsavedChanges) {
      await MessagePopup({
        icon: "warning",
        title: "Unsaved Changes",
        message:
          "Save your changes before going to Custom Template Configuration",
      });
      return;
    }
    navigate("/custom-config", { state: { data: params.data } });
  };

  const onSelectionChanged = (event) => {
    const selected = event.api.getSelectedRows();
    const combinationDetails = selected.map((row) => ({
      bottler: BottlerName ?? "",
      locationName: null,
      customerName: row.customerName ?? "",
    }));

    setCombinationDetails(combinationDetails);
  };

  const onSaveHandler = async () => {
    const selectedRows = filteredData.filter((row) => row.isDataChanged);
    const invalidRow = selectedRows.find(
      (row) =>
        row.shortTermDuration === null ||
        row.shortTermDuration === "" ||
        row.longTermDuration === null ||
        row.longTermDuration === "" ||
        row.longTermGranularity === null ||
        row.longTermGranularity === ""
    );

    if (invalidRow) {
      MessagePopup({
        icon: "error",
        title: "Invalid Data",
        message: `Missing required fields`,
      });
      return;
    }
    const result = await MessagePopup({
      title: "Confirm Save",
      html: `<p>Are you sure want to save the Configuration?</p>`,
      showCancelButton: true,
      confirmButtonText: "Ok",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#000000",
      cancelButtonColor: "#808080",
    });
    if (!result.isConfirmed) return;

    const requestBody = selectedRows.map((row) => ({
      customerId: row.customerId,
      customerName: row.customerName,
      shortTermDuration: row.shortTermDuration,
      shortTermGranularity:
        row.shortTermGranularity === null ? "WEEK" : row.shortTermGranularity,
      longTermDuration: row.longTermDuration,
      longTermGranularity: row.longTermGranularity,
    }));

    try {
      const response = await ApiService.put(
        `/v1/Onboard/updateCustomerConfig`,
        requestBody
      );
      if (response.data.status === "success") {
        MessagePopup({
          icon: "success",
          title: "Success",
          message: "Configuration saved successfully.",
        });
        setHasUnsavedChanges(false);
      }

      if (gridRef.current && gridRef.current.api) {
        gridRef.current.api.refreshCells({ force: true });
      }
      gridRef.current.api.deselectAll();
      setCombinationDetails([]);
      fetchUserDetails();
    } catch (error) {
      MessagePopup({
        icon: "error",
        title: "Error",
        message: "Failed to save configuration. Please try again.",
      });
    }
  };

  const onGrid = (params) => {
    const gridApi = params.api;
    if (gridApi) {
      gridApi.sizeColumnsToFit();
    } else {
      console.error("Grid API is not available.");
    }
  };
  // const getRowStyle = (params) => {
  //   if (params.node && params.node.isSelected && params.node.isSelected()) {
  //     return {
  //       border: "1.5px solid red",
  //       borderRadius: "4px",
  //     };
  //   }
  //   return {};
  // };
  const getRowStyle = (params) => {
    const styles = {};
    if (params.data.isDataChanged) {
      styles.border = "1.5px solid red";
      styles.borderRadius = "4px";
    }
    return styles;
  };
  return (
    <>
      <div>
        <Box>
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
            sx={{ mb: 2, mt: 2 }}
          >
            <Link
              href="/bottler-onboarding"
              onClick={(e) => {
                e.preventDefault();
                navigate("/bottler-onboarding");
              }}
              style={{ color: "black", textDecoration: "underline" }}
            >
              Bottler Configuration
            </Link>

            <Typography color="text.primary">
              Forecast Partner Configuration
            </Typography>
          </Breadcrumbs>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // This pushes children to opposite ends
              marginTop: "20px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography variant="subtitle1" align="left" gutterBottom>
                Forecast Partner Configuration
              </Typography>
              <InfoPopover margin="0 0 3px 0" />
            </Box>
            <Grid item xs={12} sm={1} display="flex" justifyContent="flex-end">
              <ButtonComponent
                bgColor="black"
                color="white"
                label="Save"
                fullWidth={false}
                onClick={onSaveHandler}
                disabled={!hasUnsavedChanges}
              />
            </Grid>
          </Box>
          <Typography variant="body1" sx={{ marginBottom: "10px" }}>
            Bottler: {BottlerName || ""}
          </Typography>
          {loading ? (
            <Skeleton
              variant="rectangular"
              height={"67vh"}
              animation="pulse"
              style={{ marginBottom: "16px", borderRadius: "8px" }}
            />
          ) : (
            <DataTable
              ref={gridRef}
              columns={PartnerColumnDefinition}
              rows={filteredData || []}
              tableHeight={"67vh"}
              suppressMovableColumns={true}
              suppressHorizontalScroll={false}
              suppressPaginationPanel={false}
              pagination={pagination}
              paginationPageSize={paginationPageSize}
              paginationPageSizeSelector={paginationPageSizeSelector}
              onGridReady={onGrid}
              rowSelection="multiple"
              onCellValueChanged={onCellValueChanged}
              onSelectionChanged={onSelectionChanged}
              getRowStyle={getRowStyle}
              singleClickEdit={true}
              //getRowClass={getRowClass}
            />
          )}
        </Box>
      </div>
    </>
  );
}
export default ForecastPartnerConfiguration;
